import axios from "axios";
import { api } from "./api_route";

export const getUserRoleRoute = async (values) => {
  try {
    const result = await axios.post(`${api}/userRoute/allRoute`, {
      values,
    });

    return result.data;
  } catch (error) {
    if (!window.location.pathname == "/") {
      window.location.href = "/";
    }
    return [];
  }
};

export const allUserRoutes = async (values) => {
  try {
    const result = await axios.get(`${api}/userRoute/allUserRoute`);
    return result.data;
  } catch (error) {
    return [];
  }
};

export const singleUserRoutes = async (values) => {
  try {
    const result = await axios.post(`${api}/userRoute/singleRoleRoute`, {
      values,
    });
    return result.data;
  } catch (error) {
    return [];
  }
};

export const updateUserRoleRoutes = async (values) => {
  try {
    const result = await axios.post(`${api}/userRoute/updateRoleRoute`, {
      values,
    });

    return result.data;
  } catch (error) {
    return [];
  }
};

export const newUserRoleRoutes = async (values) => {
  try {
    const result = await axios.get(`${api}/userRoute/newUserRole`);
    return result.data;
  } catch (error) {
    return [];
  }
};


export const createRoleRouteItem = async (values) => {
  try {
    const result = await axios.post(
      `${api}/userRoute/create`,
      values
    );
    return result.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Create failed",
    };
  }
};


export const updateRoleRouteItem = async (id, values) => {
  try {
    const result = await axios.put(
      `${api}/userRoute/update/${id}`,
      values
    );
    return result.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Update failed",
    };
  }
};

export const getAllRoleRouteItems = async (userId) => {
  try {
    const result = await axios.get(
      `${api}/userRoute/list`,{
      params: { userId },
      }
    );
    return result.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Fetch failed",
      data: [],
    };
  }
};

